
export function useNavigationMenu() {
    const state = useGlobalState();

    state.navigationMenu.value = [
        {
            label: 'Users',
            to: '/users',
            icon: 'fa-users',
            separator: false
        },
        {
            label: 'Accounts',
            to: '/accounts',
            icon: 'fa-umbrella',
            separator: false
        },
        {
            // The admin-default layout renders the sidebar via AppSidebar, whose
            // mapMenuItem reads `items` for sub-items (a group needs no `to` of its own).
            label: 'Operations',
            icon: 'fa-gears',
            separator: false,
            alwaysOpen: true,
            items: [
                {
                    label: 'Student Progress',
                    to: '/student-progress',
                    icon: 'fa-bars-progress',
                },
            ],
        },
    ].filter(Boolean) as TNavigationMenuItem[];
}
